import { PROJECT_TEMPLATES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/project_templates_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'PROJECT_FORM_PROJECT_TEMPLATES_AUTOCOMPLETE',
	'projectTemplatesIndex',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
